import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vant, { Lazyload, Icon, Popup, Dialog } from 'vant';
import 'vant/lib/index.css';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
/*import VConsole from 'vconsole';

let vConsole = new VConsole();
export default vConsole;*/

Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Element);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
